import React from "react";
import AdminUserRoles from "../components/AdminUserRoles";

export default function AdminUsersPage() {
  return (
    <div className="max-w-5xl mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6">🔐 Administration des utilisateurs</h1>
      <AdminUserRoles />
    </div>
  );
}
